import { imageSrc } from "@/lib/utils";
import { cn } from "@/lib/cn";

type SafeImageProps = {
  src: string | null | undefined;
  alt: string;
  className?: string;
  fill?: boolean;
  sizes?: string;
  width?: number;
  height?: number;
  priority?: boolean;
  style?: React.CSSProperties;
  onError?: () => void;
};

export function SafeImage({
  src,
  alt,
  className,
  fill,
  width,
  height,
  style,
  onError,
}: SafeImageProps) {
  const valid = imageSrc(src);
  if (!valid) return null;

  if (fill) {
    return (
      <img
        src={valid}
        alt={alt}
        className={cn("absolute inset-0 h-full w-full", className)}
        style={style}
        loading="lazy"
        onError={onError}
      />
    );
  }

  return (
    <img
      src={valid}
      alt={alt}
      width={width}
      height={height}
      className={className}
      style={style}
      loading="lazy"
      onError={onError}
    />
  );
}
